<div class="ml-0 mr-0">

  <div *ngIf="linkExpired" class="expired-container">
    <div class="expired-card" role="alert">
      <div class="expired-icon" aria-hidden="true">!</div>
      <h2 class="expired-title">This link is now expired</h2>
      <p class="expired-description">
        For any questions, please contact your clinic.
      </p>
    </div>
  </div>

  <div *ngIf="!linkExpired && errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <!-- <button *ngIf="!errorMessage" class="btn btn-outline-primary me-2" (click)="addNew($event)">
    Add New Family Member
  </button> -->

  <div class="row" *ngIf="!linkExpired">
    <div class="col-lg-6 mb-3" *ngFor="let submission of response">
      <div class="card h-100">
        <div class="card-header d-flex justify-content-between">
          <span>{{ submission.data.firstName }} {{ submission.data.lastName }}</span>
          <span>{{ submission.data.localStatus }}</span>
        </div>

        <div class="card-body">
          <p class="card-text">
            <span class="label">Email:</span>
            <span>{{ submission.data.patientEmail }}</span>
          </p>

          <p class="card-text">
            <span class="label">Birth Date:</span>
            <span>
              {{
                submission.data.birthDatePatientInfo
                  ? (submission.data.birthDatePatientInfo | date:'MM-dd-yyyy')
                  : submission.data.day
              }}
            </span>
          </p>

          <p class="card-text">
            <span class="label">Legal Sex:</span>
            <span>{{ submission.data.sex1 }}</span>
          </p>

          <p class="card-text">
            <span class="label">Reason for coming in:</span>
            <span class="d-block text-wrap">{{ submission.data.reasonForComingIn }}</span>
          </p>

          <p class="card-text">
            <span class="label">Payor:</span>
            <span class="text-wrap">{{ submission.data.isPatinetCoveredByInsurance }}</span>
          </p>
        </div>

        <div class="card-footer">
          <button class="btn-custom" (click)="onClick(submission)" type="button">
            {{ submission.data.localStatus === 'Intake Form-Submitted' ? 'View' : 'Complete Medical Intake Forms' }}
          </button>
          <span class="expired-notice" *ngIf="submission.data.localStatus === 'Intake Form-Submitted'">
            Your link is expired.
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
